import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const Container = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: ${props => (props.selected ? 'flex-end' : 'flex-start')};
  opacity: ${props => (props.selected ? '1' : '0.7')};
  align-items: center;
  width: 80px;
  height: 30px;
  padding: 0 5px;
  border-radius: 20px;
  background-color: #15ac79;
  color: #fff;
  font-size: 12;

  .slide-label {
    margin: 0 6px;
  }
`;

const SlidingRound = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: #fff;
`;

export const SlideSelect = props => {
  return (
    <Container selected={props.selected} onClick={props.onChange}>
      {props.selected && <span className="slide-label">{props.checkedLabel}</span>}
      <SlidingRound />
      {!props.selected && <span className="slide-label">{props.notCheckedLabel}</span>}
    </Container>
  );
};
